<template>
  <div
    v-if="showModalProjectOwner"
    class="modal-card"
    :class="$style.container"
  >
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{
          isReclaimProjectOwnership
            ? 'Request Project Ownership'
            : 'Change Project Administrator'
        }}
      </p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>

    <section class="modal-card-body" :class="$style.body">
      <!-- if project owner request exists -->
      <div v-if="disableProjectOwnerOption">
        <div :class="$style.pendingRequestContent">
          <p>
            A response is still pending for your last request. You may request
            to change the project administrator again when your last request
            expires in <b>{{ remainingDays }} day(s).</b>
          </p>
          <br />
          <p :class="$style.clickHereStyle" @click="cancelRequest()">
            Click here
          </p>
          <p :class="$style.clickHereAdjecent">
            if you wish to cancel your last request.
          </p>
        </div>
        <br />
      </div>

      <!-- info text -->
      <div :class="$style.infoTextContainer">
        <p v-if="isReclaimProjectOwnership">
          A request will be sent to the current admin. You will be notified when
          your request is accepted or declined.
        </p>
        <p v-else-if="isAdmin">
          A request will be sent to the selected admin. Current admin, new
          admin, and you will be notified when it is accepted or declined. Only
          users with a PACES subscription can be appointed as project
          administrator.
        </p>
        <p v-else>
          A request will be sent to the selected admin, and you will be notified
          when it is accepted or declined. Only users with a PACES subscription
          can be appointed as project administrator.
        </p>
      </div>

      <!-- Select new project owner -->
      <b-field label="New Project Administrator">
        <b-dropdown
          aria-role="list"
          v-model="newRequestedProjectOwner"
          :class="$style.dropdownContainer"
          :disabled="isReclaimProjectOwnership || disableProjectOwnerOption"
        >
          <button
            class="button simple-dropdown-button"
            slot="trigger"
            slot-scope="{ active }"
          >
            <span
              :class="{
                [$style.disableText]: !newRequestedProjectOwner,
              }"
            >
              {{
                !newRequestedProjectOwner
                  ? 'Select participant'
                  : newRequestedProjectOwner.participantName
              }}
            </span>
            <b-icon
              class="dropdown-arrow-icon-down"
              type="is-black"
              :icon="active ? 'chevron-up' : 'chevron-down'"
              size="is-small"
            />
          </button>
          <b-dropdown-item
            aria-role="listitem"
            custom
            class="simple-dropdown-item"
          >
            <b-field>
              <b-input
                :class="$style.searchField"
                v-model="searchTerm"
                placeholder="Search"
                icon="magnify"
                pack="mdi"
              >
              </b-input>
              <b-dropdown
                v-model="statusFilter"
                aria-role="list"
                class="participant-subscription-dropdown-container"
              >
                <button
                  class="button participant-subscription-dropdown"
                  slot="trigger"
                  slot-scope="{ active }"
                >
                  <span class="text-input">
                    {{
                      statusFilter === participantSubscriptionStatus.all
                        ? 'All Subscription Status'
                        : statusFilter === participantSubscriptionStatus.valid
                        ? 'Subscribed to PACES'
                        : 'Not subscribed to PACES'
                    }}
                  </span>
                  <b-icon
                    type="is-black"
                    :icon="active ? 'chevron-up' : 'chevron-down'"
                    size="is-small"
                  />
                </button>

                <b-dropdown-item
                  :value="value"
                  v-for="value in participantSubscriptionStatus"
                  :key="value"
                  aria-role="listitem"
                  class="participant-subscription-dropdown-item"
                >
                  {{
                    value === participantSubscriptionStatus.all
                      ? 'All Subscription Status'
                      : value === participantSubscriptionStatus.valid
                      ? 'Subscribed to PACES'
                      : 'Not subscribed to PACES'
                  }}
                </b-dropdown-item>
              </b-dropdown>
            </b-field>
          </b-dropdown-item>
          <div v-if="participants.length > 0">
            <b-dropdown-item
              aria-role="listitem"
              v-for="(participant, index) in participants"
              :key="index"
              :value="participant"
              class="data-timestamp-dropdown-item"
              :disabled="
                participant.subscriptionStatus === 'invalid' ||
                !participant.isValidProjectParticipant
                  ? true
                  : false
              "
            >
              <p>{{ participant.participantName }}</p>
              <div :class="$style.participantSubscibeStyle">
                <div>
                  {{ getParticipantRoles(participant) }}
                </div>
                <div
                  v-if="participant.subscriptionStatus === 'valid'"
                  :class="$style.subscribeTabText"
                >
                  SUBSCRIBED TO PACES
                </div>
                <div
                  v-if="participant.subscriptionStatus === 'invalid'"
                  :class="$style.unsubscribeTabText"
                >
                  NOT SUBSCRIBED TO PACES
                </div>
                <div
                  v-if="
                    !participant.isValidProjectParticipant &&
                    participant.subscriptionStatus === 'valid'
                  "
                  :class="$style.pendingTabText"
                >
                  PENDING PROJECT INVITATION
                </div>
              </div>
            </b-dropdown-item>
          </div>
          <div v-else>
            <b-dropdown-item
              aria-role="listitem"
              class="data-timestamp-dropdown-item"
            >
              <p :class="$style.noResultText">Result Not Found</p>
            </b-dropdown-item>
          </div>
        </b-dropdown>
      </b-field>

      <hr class="mt1 mb1 ml0 mr0" />

      <!-- Current project owner details -->
      <b-field label="Current Project Administrator">
        <b-input
          v-if="projectOwnerName && projectOwnerEmail"
          :placeholder="projectOwnerName"
          :disabled="true"
        >
        </b-input>
      </b-field>

      <!-- Change current project owner container -->
      <div :class="$style.currentOwnerActionContainer">
        <!-- Select action for Current project owner -->
        <b-field :class="$style.actionListOption">
          <b-radio
            :class="$style.actionOption"
            v-model="currentOwnerAction"
            :name="OwnerActionEnum.removeFromProject"
            :native-value="OwnerActionEnum.removeFromProject"
            @input="onCurrentOwnerAction"
          >
            Remove from the project
          </b-radio>
          <b-radio
            :class="$style.actionOption"
            v-model="currentOwnerAction"
            :name="OwnerActionEnum.appointNewRole"
            :native-value="OwnerActionEnum.appointNewRole"
            @input="onCurrentOwnerAction"
          >
            Appoint a new role
          </b-radio>
        </b-field>

        <div v-if="currentOwnerAction === OwnerActionEnum.appointNewRole">
          <!-- Select role for Current project owner -->
          <b-field label="Role">
            <b-dropdown
              aria-role="list"
              v-model="selectedRoleForCurrentProjectOwner"
              class="simple-dropdown"
            >
              <button
                class="button simple-dropdown-button"
                slot="trigger"
                slot-scope="{ active }"
              >
                <span
                  :class="{
                    [$style.disableText]: !selectedRoleForCurrentProjectOwner,
                  }"
                >
                  {{
                    !selectedRoleForCurrentProjectOwner
                      ? 'Select role'
                      : selectedRoleForCurrentProjectOwner
                  }}
                </span>
                <b-icon
                  class="dropdown-arrow-icon-down"
                  type="is-black"
                  :icon="active ? 'chevron-up' : 'chevron-down'"
                  size="is-small"
                />
              </button>
              <b-dropdown-item
                aria-role="listitem"
                v-for="(role, index) in projectOwnerRoleOptions"
                :key="index"
                :value="role.label"
                class="data-timestamp-dropdown-item"
              >
                {{ role.label }}
              </b-dropdown-item>
            </b-dropdown>
          </b-field>

          <!-- Select sites for Current project owner -->
          <b-field label="Site">
            <b-dropdown
              :multiple="true"
              :class="[$style.dropdownContainer, $style.siteDropdownContainer]"
            >
              <button
                class="button simple-dropdown-button"
                :class="$style.triggerButton"
                slot="trigger"
                slot-scope="{ active }"
              >
                <span
                  v-if="selectedSiteNames.length > 65 && !checkedAllSites"
                  class="text-input"
                >
                  <b-tooltip
                    :label="selectedSiteNames"
                    position="is-top"
                    size="is-small"
                  >
                    {{ selectedSiteNames.substring(0, 65) + '...' }}
                  </b-tooltip>
                </span>
                <span v-else class="text-input">
                  <span
                    :class="{
                      [$style.disableText]: !selectedSiteNames.length,
                    }"
                  >
                    {{
                      !selectedSiteNames.length
                        ? 'Select Site'
                        : selectedSiteNames
                    }}
                  </span>
                </span>
                <b-icon
                  type="is-black"
                  :icon="active ? 'chevron-up' : 'chevron-down'"
                  size="is-small"
                />
              </button>

              <b-dropdown-item :custom="true">
                <label>
                  <div :class="$style.item">
                    <input
                      type="checkbox"
                      :checked="checkedAllSites"
                      @input="
                        ($event) => handleCheckAllSites($event.target.checked)
                      "
                    />
                    <b>All Sites</b>
                  </div>
                </label>
              </b-dropdown-item>
              <b-dropdown-item
                v-for="(site, index) in sites"
                :key="`options${index}`"
                :custom="true"
              >
                <label>
                  <div :class="$style.item">
                    <input
                      type="checkbox"
                      :value="site"
                      v-model="selectedSitesForCurrentProjectOwner"
                    />
                    <p>
                      {{ site.name }} <br />
                      <span>{{ site.address }}</span>
                    </p>
                  </div>
                </label>
              </b-dropdown-item>
            </b-dropdown>
          </b-field>
        </div>
      </div>
    </section>

    <footer class="modal-card-foot">
      <button
        class="button is-primary is-rounded"
        @click="sendRequest"
        :disabled="disabledButton"
      >
        <p>{{ buttonText }}</p>
      </button>
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import { RootState } from '@/store/store';
import {
  ChangeProjectOwnerPayload,
  GetExistingProjectOwnerRequestPayload,
  ParticipantListDTO,
  ParticipantWithSubscriptionDTO,
  OwnerActionEnum,
  ProjectSite,
  Site,
  ChangeProjectOwnerDTO,
  ParticipantSitesDTO,
} from '@/store/modules/projects/types/projects.types';
import BaseDropDown from '@/components/base/BaseDropDown.vue';
import dayjs from 'dayjs';
import { useAuthState } from '@/utils/store.util';
import { GeneralRoles } from '@/jbi-shared/types/casbin-permission.types';
import ProjectOwnerCancelRequestModal from './ProjectOwnerCancelRequest.vue';
import { ToastProgrammatic as Toast } from 'buefy';
import {
  CheckSubscriptionStatusByEmailIdsPayload,
  UserSubscriptionStatusByEmailPayload,
} from '@/store/modules/auth/types/auth.types';
import { ApiState } from '@/store/types/general.types';
import { UserSubscriptionStatus } from '@/jbi-shared/types/jaas-oauth2.types';
import { useUserEmail } from '@/utils/user.util';
import { getJBIUsername } from '@/jbi-shared/util/user.utils';
import { PacesParticipantRoles } from '@/jbi-shared/types/paces-project.types';

@Component({
  components: {
    BaseDropDown,
  },
})
export default class ProjectOwnerRequestForm extends Vue {
  @Prop() public projectId!: number;
  @Prop() public projectOwnerEmail!: string;
  @Prop() public projectOwnerName!: string;
  @Prop() public isSystemAdmin!: boolean;
  @Prop({ default: false, type: Boolean })
  public isReclaimProjectOwnership!: boolean;

  public disableSendRequest: boolean = this.isReclaimProjectOwnership
    ? false
    : true;
  public showModalProjectOwner: boolean = false;
  public disableProjectOwnerOption: boolean = false;
  public selectedRoleForCurrentProjectOwner: PacesParticipantRoles | null = null;
  public selectedSitesForCurrentProjectOwner: Site[] = [];
  public checkedAllSites: boolean = false;
  public participantsWithSubscriptionInfo: ParticipantWithSubscriptionDTO[] = [];
  public newRequestedProjectOwner: {
    userEmail: string;
    participantName: string;
  } | null = null;
  public searchTerm: string = '';
  public statusFilter: string = '';
  public remainingDays: number = 0;
  public projectOwnerRequestId: number = 0;
  public emailToken: string = '';
  public participantSubscriptionStatus = {
    all: 'all',
    valid: 'valid',
    invalid: 'invalid',
  };
  public confirmSendRequest: ChangeProjectOwnerDTO | null = null;
  public currentOwnerAction: OwnerActionEnum = OwnerActionEnum.none;

  @Action('projects/changeProjectOwnerRequest')
  public changeProjectOwnerRequest!: (
    payload: ChangeProjectOwnerPayload,
  ) => void;

  @State(
    (state: RootState) => state.projects.apiState.changeProjectOwnerRequest,
  )
  public changeProjectOwnerRequestState!: ApiState;

  @Action('projects/getExistingProjectOwnerRequest')
  public getExistingProjectOwnerRequest!: (
    payload: GetExistingProjectOwnerRequestPayload,
  ) => void;

  @State((state: RootState) => state.projects.existingProjectOwnerRequest)
  public existingProjectOwnerRequestState!: ApiState;

  @Action('auth/checkSubscriptionStatusByEmailIds')
  public checkSubscriptionStatusByEmailIds!: (
    payload: CheckSubscriptionStatusByEmailIdsPayload,
  ) => void;

  @State((state: RootState) => state.auth.userSubscriptionStatusByEmail)
  public userSubscriptionStatusByEmail!: UserSubscriptionStatusByEmailPayload[];

  @Action('projects/getProjectParticipantsForAdmin')
  public getProjectParticipantsForAdmin!: (projectId: number) => void;

  // prettier-ignore
  @State((state: RootState) => state.projects.apiState.getProjectParticipantsForAdmin)
  public getProjectParticipantsState!: ApiState;

  @State((state: RootState) => state.projects.projectParticipantsForAdmin)
  public projectParticipants!: ParticipantListDTO[];

  @Action('projects/getProjectSitesForAdmin')
  public getProjectSitesForAdmin!: (projectId: number) => void;

  // prettier-ignore
  @State((state: RootState) => state.projects.apiState.getProjectSitesForAdmin)
  public getProjectSitesState!: ApiState;

  @State((state: RootState) => state.projects.projectSitesForAdmin)
  public projectSites!: ProjectSite[];

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }

  get OwnerActionEnum() {
    return OwnerActionEnum;
  }

  get participants(): ParticipantWithSubscriptionDTO[] {
    let filteredParticipant = this.participantsWithSubscriptionInfo;
    if (this.searchTerm) {
      filteredParticipant = filteredParticipant.filter(
        (participant: ParticipantWithSubscriptionDTO) => {
          const participantName = participant.participantName.toLowerCase();
          return participantName.includes(this.searchTerm.toLowerCase());
        },
      );
    }

    if (this.statusFilter !== 'all') {
      filteredParticipant = filteredParticipant.filter(
        (participant: ParticipantWithSubscriptionDTO) =>
          participant.subscriptionStatus ===
          (this.statusFilter as UserSubscriptionStatus),
      );
    }

    return filteredParticipant;
  }

  get projectOwnerRoleOptions() {
    return [
      {
        label: PacesParticipantRoles.ProjectCoordinator,
        value: PacesParticipantRoles.ProjectCoordinator,
      },
      {
        label: PacesParticipantRoles.DataCollector,
        value: PacesParticipantRoles.DataCollector,
      },
    ];
  }

  get sites(): Site[] {
    return this.projectSites
      ? this.projectSites.map((projectSite) => projectSite.site)
      : [];
  }

  get isAdmin(): boolean {
    const permissions = useAuthState.call(this).roles;
    return permissions.some((e) => e === GeneralRoles.Admin);
  }

  get selectedSiteNames(): string {
    this.checkedAllSites =
      this.selectedSitesForCurrentProjectOwner.length === this.sites.length;

    return this.checkedAllSites
      ? 'All Sites'
      : this.selectedSitesForCurrentProjectOwner
          .map((site) => site.name)
          .join(', ');
  }

  get disabledButton(): boolean {
    return (
      !this.validatedFromData() ||
      this.disableProjectOwnerOption ||
      this.disableSendRequest
    );
  }

  get buttonText(): string {
    if (this.isAdminNewProjectOwner && !this.isReclaimProjectOwnership) {
      return 'Save';
    }
    return 'Send Request';
  }

  get isAdminNewProjectOwner(): boolean {
    return this.isSystemAdmin &&
      this.newRequestedProjectOwner &&
      this.newRequestedProjectOwner.userEmail === this.userEmail
      ? true
      : false;
  }

  public validatedFromData(): boolean {
    if (!this.newRequestedProjectOwner) {
      return false;
    } else if (
      this.newRequestedProjectOwner.userEmail === this.projectOwnerEmail
    ) {
      return false;
    }
    if (
      this.currentOwnerAction === OwnerActionEnum.removeFromProject &&
      this.newRequestedProjectOwner
    ) {
      return true;
    } else if (
      this.currentOwnerAction === OwnerActionEnum.appointNewRole &&
      this.newRequestedProjectOwner &&
      this.selectedRoleForCurrentProjectOwner &&
      this.selectedSitesForCurrentProjectOwner.length > 0
    ) {
      return true;
    }

    return false;
  }

  public getParticipantRoles(
    participant: ParticipantWithSubscriptionDTO,
  ): string {
    return '';
  }

  public handleCheckAllSites(value: boolean) {
    this.checkedAllSites = value;
    this.selectedSitesForCurrentProjectOwner = [];
    if (value) {
      this.selectedSitesForCurrentProjectOwner = [...this.sites];
    }
  }

  public onCurrentOwnerAction(value: OwnerActionEnum) {
    this.currentOwnerAction = value;
  }

  @Watch('userSubscriptionStatusByEmail')
  @isTruthy
  public async userSubscriptionStatus(
    subscriptionDetails: UserSubscriptionStatusByEmailPayload[],
  ) {
    if (this.projectParticipants && !this.isReclaimProjectOwnership) {
      const participantsSubscriptionDto: ParticipantWithSubscriptionDTO[] = [];
      this.projectParticipants.forEach((participant: ParticipantListDTO) => {
        if (this.projectOwnerEmail === participant.userEmail) {
          return;
        }
        const userSubscriptionStatus = subscriptionDetails.find(
          (subscriptionDetail: UserSubscriptionStatusByEmailPayload) =>
            subscriptionDetail.user === participant.userEmail,
        );

        const participantNameEmail = getJBIUsername(
          participant.userEmail,
          participant.participant
            ? participant.participant.user.oicPayload
            : undefined,
        );

        const isValidProjectParticipant: boolean = participant.participantSites.every(
          (site: ParticipantSitesDTO) =>
            !site.invitationId && !site.invitationToken,
        );

        const participantSubscriptionDto: ParticipantWithSubscriptionDTO = {
          ...participant,
          participantName: participantNameEmail,
          subscriptionStatus: userSubscriptionStatus
            ? (userSubscriptionStatus.subscriptionStatus as UserSubscriptionStatus)
            : UserSubscriptionStatus.INVALID,
          isValidProjectParticipant: isValidProjectParticipant,
        };

        participantsSubscriptionDto.push(participantSubscriptionDto);
      });

      /** if one of the participant have valid subscription and have accepted all site invites for all roles */
      this.disableSendRequest = !participantsSubscriptionDto.some(
        (participantInfo: ParticipantWithSubscriptionDTO) =>
          participantInfo.subscriptionStatus === UserSubscriptionStatus.VALID &&
          participantInfo.participant &&
          participantInfo.participantSites.every(
            (ps: ParticipantSitesDTO) => !ps.invitationId,
          ),
      );
      this.participantsWithSubscriptionInfo = participantsSubscriptionDto;
    }
  }

  public sendRequest() {
    if (this.newRequestedProjectOwner && this.validatedFromData()) {
      const systemAdminEmail =
        this.isSystemAdmin && this.userEmail ? this.userEmail : null;

      const projectOwnerRequest: ChangeProjectOwnerPayload = {
        newRequestedOwnerEmail: this.newRequestedProjectOwner.userEmail,
        projectId: this.projectId,
        currentOwnerEmail: this.projectOwnerEmail,
        currentOwnerAction: this.currentOwnerAction,
        assignedRoleForCurrentOwner: this.selectedRoleForCurrentProjectOwner,
        assignedSitesForCurrentOwner: this.selectedSitesForCurrentProjectOwner.map(
          (site) => site.id,
        ),
        systemAdminEmail,
        isSystemAdmin: this.isSystemAdmin,
        isReclaimProject: this.isReclaimProjectOwnership,
      };

      this.confirmSendRequest = {
        isAdminNewProjectOwner: this.isAdminNewProjectOwner,
        currentProjectOwnerEmail: this.projectOwnerEmail,
        newRequestedProjectOwnerEmail: this.newRequestedProjectOwner.userEmail,
      };

      this.changeProjectOwnerRequest(projectOwnerRequest);
      this.$emit('close');
    }
  }

  public cancelRequest() {
    const modalContent =
      'After your last request is cancelled, the recipient of this request will no longer be able to respond to it.';
    this.$buefy.modal.open({
      parent: this,
      component: ProjectOwnerCancelRequestModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        modalContent,
        projectOwnerRequestId: this.projectOwnerRequestId,
        projectId: this.projectId,
        token: this.emailToken,
        isReclaimProject: false,
        isSystemAdmin: this.isSystemAdmin,
      },
      events: {
        close: () => {
          this.$emit('close');
        },
        confirm: () => {
          Toast.open({
            message: `Project administration change request cancelled`,
            position: 'is-top',
            type: 'is-dark',
            duration: 3500,
          });
          this.getExistingProjectOwnerRequest({
            projectId: this.projectId,
            isSystemAdmin: this.isSystemAdmin,
          });
        },
      },
    });
  }

  @Watch('getProjectParticipantsState')
  @isTruthy
  public onGetProjectParticipantsState() {
    if (this.projectParticipants) {
      this.checkSubscriptionStatusByEmailIds({
        email_list: this.projectParticipants.map(
          (participant) => participant.userEmail,
        ),
      });
    }
  }

  @Watch('existingProjectOwnerRequestState')
  @isTruthy
  public watchExistingProjectOwnerRequestState(newValue: any) {
    this.disableProjectOwnerOption = newValue.isNewProjectOwnerRequest
      ? false
      : true;

    if (newValue.expireDate) {
      this.remainingDays = dayjs(newValue.expireDate).diff(new Date(), 'day');
      this.projectOwnerRequestId = newValue.projectOwnerRequestId;
      this.emailToken = newValue.token;
    }
  }

  @Watch('changeProjectOwnerRequestState')
  @isTruthy
  public watchChangeProjectOwnerRequestState() {
    this.$emit('confirm', this.confirmSendRequest);
    this.$emit('close');
  }

  public mounted(): void {
    this.showModalProjectOwner = true;
    this.getProjectSitesForAdmin(this.projectId);

    if (this.isReclaimProjectOwnership && this.userEmail) {
      this.newRequestedProjectOwner = {
        userEmail: this.userEmail,
        participantName: 'You',
      };
    } else {
      this.getProjectParticipantsForAdmin(this.projectId);
      this.getExistingProjectOwnerRequest({
        projectId: this.projectId,
        isSystemAdmin: this.isSystemAdmin,
      });
    }
    this.statusFilter = 'all';
  }
}
</script>

<style lang="scss" module>
.body {
  min-height: 200px;
}
.container {
  :global(.modal-card-body) {
    overflow: visible;
  }

  .triggerButton {
    width: 100%;
    justify-content: space-between;

    span {
      font-weight: normal;
    }
  }

  .siteDropdownContainer.dropdown-menu {
    max-height: 9.5rem;
  }

  .dropdownContainer {
    :global(.dropdown-menu) {
      padding-top: 0;
      overflow-y: auto;
      max-height: 15rem;
      overflow: auto;
      border-radius: 4px;
      box-shadow: rgba(0, 0, 0, 0.15) 0px 4px 12px;

      :global(.dropdown-content) {
        padding-top: 0px;
        padding-bottom: 0px;

        :global(.dropdown-item) {
          border-bottom: 0.5px solid $grey-border;

          &:hover,
          label {
            background: #f7fbff;
            cursor: pointer;
          }
        }
      }
    }

    .item {
      padding: 0.25rem 0.5rem;
      display: flex;

      input {
        margin-right: 1rem;
      }

      span {
        color: #9f9f9f;
      }
    }
  }
}
.header,
.text {
  display: block;
  height: 100%;
  max-width: 100%;
  text-overflow: clip;
  white-space: normal;
  text-align: start;
  font-size: 14px;
  line-height: 17px;
  color: #444f51;
  padding: 0.7rem 0.75rem 1.5rem 0.75rem;
  flex-basis: 100%;
}

.searchField {
  top: 10px;
  width: 80%;
  div {
    span {
      padding-left: 12px !important;
      color: #71797c !important;
    }
    input {
      padding-left: 2.8em !important;
    }
  }
}
.subscribeTabText {
  color: #21b5ea;
  background-color: #eff7ff;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 4px;
  font-size: 10px;
  margin-left: 1rem;
  margin-right: 4px;
}
.unsubscribeTabText {
  color: #5e6b81;
  background-color: #f6f7f8;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 4px;
  font-size: 10px;
  margin-left: 1rem;
  margin-right: 4px;
}
.participantSubscibeStyle {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.searchFieldStyle {
  width: 10px;
}
.pendingRequestContent {
  background-color: #eff7ff;
  border-radius: 4px;
  width: 585px;
  height: 60px;
  font-size: 14px;
  padding: 13px 10px 90px 12px;
}
.clickHereStyle {
  color: #1d70b8;
  font-weight: 700;
  display: inline-block;
  cursor: pointer;
}
.clickHereAdjecent {
  padding-left: 5px;
  display: inline-block;
}
.noResultText {
  font-size: 14px;
  font-weight: 400;
  overflow: auto;
  text-align: center;
}
.subscriptionStatusStyle {
  width: 90%;
}
.pendingTabText {
  color: #ff9700;
  background-color: #fff5e6;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 4px;
  font-size: 10px;
  margin-right: 0.5rem;
}

.disableText {
  color: #dfdfdf !important;
}

.currentOwnerActionContainer {
  .actionListOption {
    margin-top: 1rem;
    display: flex;

    .actionOption {
      padding-right: 32px;
      &:global(.b-radio.radio input[type='radio'] + .check) {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }
}

.infoTextContainer {
  margin-bottom: 1rem;
}

.dropdown-menu {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
